export const LimitToI18nKey = {
  snippets: {
    name: 'snippets',
    nextTierLimit: 5000,
    subtitle: 'subtitle'
  },
  documents: {
    name: 'documents',
    nextTierLimit: 5000,
    subtitle: 'subtitle-branding'
  },
  'cms-landing-pages': {
    name: 'landingPages',
    nextTierLimit: 10000,
    subtitle: 'subtitle-branding'
  },
  'cms-site-pages': {
    name: 'websitePages',
    nextTierLimit: 50,
    subtitle: 'subtitle-branding'
  },
  templates: {
    name: 'templates',
    nextTierLimit: 5000,
    subtitle: 'subtitle-branding'
  }
};